export default __webpack_public_path__ + "images/13db90e2d1fb436e9cbb19049d465d23-chatInactiveIcon.svg";